import { useRelodeReducer, logAction, useSnackMiddleware } from "@relode/core";
import * as React from "react";

import {
    CandidateSearchActions,
    useCandidateSearchActions,
} from "./candidateSearchActions";
import { useSearchHandlers } from "./candidateSearchHandlers";
import { searchReducer } from "./candidateSearchReducer";
import { initialSearchState, SearchState } from "./candidateSearchState";

const SearchContext = React.createContext(undefined);

export const CandidateSearchProvider = props => {
    const [state, dispatch] = useRelodeReducer(
        searchReducer,
        initialSearchState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useCandidateSearchActions(state, dispatch);

    useSearchHandlers(state, actions);
    const value = React.useMemo(
        () => [state, actions] as [SearchState, CandidateSearchActions],
        [actions, state]
    );

    return <SearchContext.Provider value={value} {...props} />;
};

export const useSearch = () => {
    const context = React.useContext(SearchContext);
    if (!context) {
        throw new Error("useSearch must be used within a SearchProvider");
    }

    return context as [SearchState, CandidateSearchActions];
};
